const GENERATION_URL_MODAL = 'GENERATION_URL_MODAL';
const CREATE_ACCOUNT_MODAL = 'CREATE_ACCOUNT_MODAL';
const EDIT_ACCOUNT_MODAL = 'EDIT_ACCOUNT_MODAL';

export { 
  GENERATION_URL_MODAL,
  CREATE_ACCOUNT_MODAL,
  EDIT_ACCOUNT_MODAL
}